module.exports = __webpack_public_path__ + "media/application/images/icons/icon-reporting-188e702720c65fadfeb06f7657742110.svg";